// extracted by mini-css-extract-plugin
export default {"container":"orders-panel_container__oujCX","header":"orders-panel_header__pV4um","list":"orders-panel_list__LII8V","empty-button":"orders-panel_empty-button__YKn6+"};